/**
 * @file   src\components\Introduction\AgentProfileViewModal.js
 * @brief  This file is responsible for the view of agent details modal.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import noImage from "../../images/no-image-placeholder.png";
import { getUserDetails } from "../../services/userprofileService";

const AgentProfileViewModal = (props) => {
  const { isTitleShow } = props;

  // Check from the messages screen or not
  const isFromMessage = props.isFromMessage ? props.isFromMessage : false;
  // Initialize component state variables.
  const [userDetails, setUserDetails] = useState([]);

  // To fetch the user details when the props user id changes
  useEffect(() => {
    if (props?.userId) {
      getUserDetailsById();
    }
  }, [props?.userId]);

  // To get the user details by id
  const getUserDetailsById = async () => {
    await getUserDetails({ id: props?.userId })
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        if (response.errorCode === 0 && responseResult) {
          setUserDetails(responseResult && responseResult[0]);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  return (
    <Modal
      show
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-settings agent-modal"
    >
      <Modal.Body>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            props.onClose(isFromMessage);
          }}
        ></button>
        <div className="agent-title">
          <h3>Agent Profile</h3>
          {isTitleShow && (
            <p className="f-size-16">
              A licensed real-estate agent is representing this property.
            </p>
          )}
        </div>
        <div className="profile-pic-sec">
          {userDetails?.Img ? (
            <figure className="brdr-rs-200">
              <img src={userDetails?.Img ?? noImage} className="brdr-rs-200" />
            </figure>
          ) : (
            <div className="profile-placeholder-wrap profile-bg-orange">
              {(userDetails?.FirstName + " " + userDetails?.LastName)
                .replace(/-/g, "")
                .match(/\b(\w)/g)}
            </div>
          )}
          <div className="profile-name">
            <h6 className="d-flex">
              {userDetails?.FirstName + " " + userDetails?.LastName}
              {userDetails?.PlanName === "Pro Member" && (
                <span className="pro-blue-badge">PRO</span>
              )}
            </h6>
            <p className="f-size-16">Agent @ {userDetails?.Company}</p>
          </div>
        </div>
        {userDetails?.Bio && (
          <div className="bio">
            <p className="title">Bio</p>
            <p> {userDetails?.Bio}</p>
          </div>
        )}
        <div className="agent-info">
          <div className="field-group">
            <label>Phone number</label>
            <p>{userDetails?.Phone}</p>
          </div>
          <div className="field-group">
            <label>Work location</label>
            <p>{userDetails?.Location}</p>
          </div>
          <div className="field-group">
            <label>Company</label>
            <p>{userDetails?.Company}</p>
          </div>
          <div className="field-group">
            <label>License number</label>
            <p>{userDetails?.LicenseNo}</p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default AgentProfileViewModal;
